/**
 * SMS global search service — migrated to typed `@tiaki/http-client` per ADR 113.
 */
import { client } from '../lib/http-client';

function unwrap<T>(result: { data?: T; error?: unknown }): T {
  if (result.error !== undefined) {
    throw result.error;
  }
  return result.data as T;
}

export interface SearchNavigatePayload {
  path: string;
  tab: string;
  subTab?: string;
  id: number;
}

export interface SearchItem {
  id: number;
  public_id: string | null;
  name: string;
  description: string;
  model: string;
}

export interface SearchGroup {
  key: string;
  menu: string;
  page: string;
  sub_page: string;
  api_path: string;
  count: number;
  items: SearchItem[];
}

export interface SearchResponse {
  limit: number;
  provider: string;
  total_count: number;
  results: SearchGroup[];
}

export function resolveSearchRoute(
  group: SearchGroup,
  itemId: number,
): SearchNavigatePayload {
  const REUNIFY_KEY = 'reunify';
  const REUNIFICATION_KEY = 'reunification';
  let slug = group.key.split('.')[0];
  if (slug === REUNIFY_KEY) slug = REUNIFICATION_KEY;
  let tab = group.page.toLowerCase();
  if (tab === REUNIFY_KEY) tab = REUNIFICATION_KEY;
  const path = `/${slug}`;
  const subTab = group.sub_page ? group.sub_page.toLowerCase() : undefined;

  return { path, tab, subTab, id: itemId };
}

export interface GlobalSearchFilters {
  query: string;
  limit?: number;
  offset?: number;
}

export async function fetchSearch(
  filters: GlobalSearchFilters = {
    query: '',
    limit: 8,
    offset: 0,
  },
): Promise<SearchResponse> {
  const { query = '', limit = 8, offset = 0 } = filters;
  const result = await client.GET('/api/v2/global-search/', {
    params: { query: { search: query, limit, offset } as never },
  });
  return unwrap(result) as unknown as SearchResponse;
}
